<template>
  <div v-if="hasCardData" class="sitter-card-box lg:w-1/2">
    <div class="mx-16 mt-16 mb-24 md:mb-56">
      <p class="flex text-body mb-12">
        What your profile looks like to families
        <curving-arrow-icon class="relative bottom-[-10px] ml-4" />
      </p>
      <SitterCard
        :name="sitterCardName"
        :yearsExperience="profilePreview.yearsExperience"
        :city="city"
        :stateAbbr="stateAbbr"
        :description="profilePreview.bio"
        :idv="idv"
        :badges="badges"
        :minRate="profilePreview.minRate"
        :maxRate="profilePreview.maxRate"
        :photoUploadAvatar="!hasPhoto"
        :photoUrl="account?.croppedPhoto"
        customClasses="max-w-[375px]"
      />
    </div>
  </div>
</template>

<script lang="ts">
import SitterCard from '@/components/sitter_card/SitterCard.vue';
import CurvingArrowIcon from '@/graphics/icons/CurvingArrowIcon.vue';
import { Account } from '@/models/account';
import { ProfileCompletePreviewData, qualificationsToBadges } from '@/lib/sitterOnboarding/profileCompletePreview';

export default {
  name: 'ProfileCompletePreview',
  components: {
    SitterCard,
    CurvingArrowIcon,
  },
  props: {
    account: {
      type: Object as () => Account | null,
      default: null,
    },
    profilePreview: {
      type: Object as () => ProfileCompletePreviewData | null,
      default: null,
    },
  },
  computed: {
    hasCardData(): boolean {
      return !!(this.account && this.profilePreview?.bio);
    },
    sitterCardName(): string {
      return `${this.account?.firstName ?? ''} ${this.account?.lastName?.[0] ?? ''}`;
    },
    city(): string {
      return this.account?.location?.cityname || '';
    },
    stateAbbr(): string {
      return this.account?.location?.stateabbr || '';
    },
    hasPhoto(): boolean {
      return !!this.account?.croppedPhoto;
    },
    idv() {
      return { verdict: 'passed' };
    },
    badges() {
      return qualificationsToBadges(this.profilePreview?.qualifications ?? []);
    },
  },
};
</script>

<style lang="scss" scoped>
.sitter-card-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffeef8;
  background-image: url('@/images/account/pink_swoop.svg');
  background-size: 100% 90%;
  background-repeat: no-repeat;
  background-position: bottom;
  min-height: 349px;
  border-radius: 4px;
}
</style>
